<template>
  <div id="app">
    <Header></Header>
    <div class="content-wrapper">
      <router-view/>
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 为.router-view添加一个外部容器，并在App.vue中应用这个类 */
.content-wrapper {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue